import { App, KnowledgeSource, KnowledgeSourceTraining, Namespace, TrainingProgress } from '@vendasta/embeddings';

export class KnowledgeSourceWithSuggestedFlag extends KnowledgeSource {
  isSuggested?: boolean;
}

/**
 * Check if training has finished (either successfully or with an error) for a knowledge source
 * @param knowledgeSourceTraining - The knowledge sourcetraining to check
 * @returns true if training is done or errored, false otherwise
 */
export function isTrainingFinished(knowledgeSourceTraining: KnowledgeSourceTraining): boolean {
  return knowledgeSourceTraining?.progress === TrainingProgress.TRAINING_DONE ||
    knowledgeSourceTraining?.progress === TrainingProgress.TRAINING_ERRORED;
}

// Embeddings IDs are only unique within a namespace. Cross-namespace KB attachment
// (DALE-555) makes ID-alone comparisons unsafe — two records in different namespaces
// can share an ID.
export function areNamespacesEqual(ns1: Namespace | null | undefined, ns2: Namespace | null | undefined): boolean {
  if (!ns1 && !ns2) return true;
  if (!ns1 || !ns2) return false;
  return (
    ns1.accountGroupNamespace?.accountGroupId === ns2.accountGroupNamespace?.accountGroupId &&
    ns1.partnerNamespace?.partnerId === ns2.partnerNamespace?.partnerId &&
    !!ns1.adminNamespace === !!ns2.adminNamespace
  );
}

export function isSameKnowledgeSource(
  a: Pick<KnowledgeSource, 'id' | 'namespace'> | null | undefined,
  b: Pick<KnowledgeSource, 'id' | 'namespace'> | null | undefined,
): boolean {
  if (!a || !b) return false;
  return a.id === b.id && areNamespacesEqual(a.namespace, b.namespace);
}

export function isSameApp(
  a: Pick<App, 'id' | 'namespace'> | null | undefined,
  b: Pick<App, 'id' | 'namespace'> | null | undefined,
): boolean {
  if (!a || !b) return false;
  return a.id === b.id && areNamespacesEqual(a.namespace, b.namespace);
}

export const WebChatWidgetAppType = 'WebChatWidget';
export const AIAssistantAppType = 'AIAssistant';
